<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiMagnifyPlusOutline } from "@mdi/js"

export default {
  name: "MagnifyPlusOutlineIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiMagnifyPlusOutline,
    }
  }
}
</script>
